var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export function enqueueVideoToggle(queue, operation) {
    var result = queue.current.catch(function () { return false; }).then(operation);
    queue.current = result.catch(function () { return false; });
    return result;
}
export function toggleLocalVideoTrack(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var mediaStreamTrack;
        var track = _b.track, deviceId = _b.deviceId, createDeviceTrack = _b.createDeviceTrack;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!!track.isMuted) return [3 /*break*/, 2];
                    return [4 /*yield*/, track.mute()];
                case 1:
                    _c.sent();
                    return [2 /*return*/, true];
                case 2:
                    if (!deviceId) {
                        throw new Error('Local video device is not specified');
                    }
                    return [4 /*yield*/, createDeviceTrack(deviceId, 'video')];
                case 3:
                    mediaStreamTrack = _c.sent();
                    if (!mediaStreamTrack) {
                        throw new Error('Failed to create local video track');
                    }
                    return [4 /*yield*/, track.replaceTrack(mediaStreamTrack, { userProvidedTrack: false })];
                case 4:
                    _c.sent();
                    return [4 /*yield*/, track.unmute()];
                case 5:
                    _c.sent();
                    return [2 /*return*/, false];
            }
        });
    });
}
export function switchLocalVideoDevice(track, deviceId, isMuted, captureOptions) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, track.restartTrack(__assign({ deviceId: deviceId }, captureOptions))];
                case 1:
                    _a.sent();
                    if (!(!isMuted && track.isMuted)) return [3 /*break*/, 3];
                    return [4 /*yield*/, track.unmute()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWxWaWRlb0NvbnRyb2xzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL2hvb2tzL2xvY2FsVmlkZW9Db250cm9scy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQW1CQSxNQUFNLFVBQVUsa0JBQWtCLENBQ2hDLEtBQW9DLEVBQ3BDLFNBQWlDO0lBRWpDLElBQU0sTUFBTSxHQUFHLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLGNBQU0sT0FBQSxLQUFLLEVBQUwsQ0FBSyxDQUFDLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQ2hFLEtBQUssQ0FBQyxPQUFPLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxjQUFNLE9BQUEsS0FBSyxFQUFMLENBQUssQ0FBQyxDQUFDO0lBQzFDLE9BQU8sTUFBTSxDQUFDO0FBQ2hCLENBQUM7QUFFRCxNQUFNLFVBQWdCLHFCQUFxQjt3REFBQyxFQUlyQjs7WUFIckIsS0FBSyxXQUFBLEVBQ0wsUUFBUSxjQUFBLEVBQ1IsaUJBQWlCLHVCQUFBOzs7O3lCQUViLENBQUMsS0FBSyxDQUFDLE9BQU8sRUFBZCx3QkFBYztvQkFDaEIscUJBQU0sS0FBSyxDQUFDLElBQUksRUFBRSxFQUFBOztvQkFBbEIsU0FBa0IsQ0FBQztvQkFDbkIsc0JBQU8sSUFBSSxFQUFDOztvQkFHZCxJQUFJLENBQUMsUUFBUSxFQUFFLENBQUM7d0JBQ2QsTUFBTSxJQUFJLEtBQUssQ0FBQyxxQ0FBcUMsQ0FBQyxDQUFDO29CQUN6RCxDQUFDO29CQUV3QixxQkFBTSxpQkFBaUIsQ0FBQyxRQUFRLEVBQUUsT0FBTyxDQUFDLEVBQUE7O29CQUE3RCxnQkFBZ0IsR0FBRyxTQUEwQztvQkFDbkUsSUFBSSxDQUFDLGdCQUFnQixFQUFFLENBQUM7d0JBQ3RCLE1BQU0sSUFBSSxLQUFLLENBQUMsb0NBQW9DLENBQUMsQ0FBQztvQkFDeEQsQ0FBQztvQkFFRCxxQkFBTSxLQUFLLENBQUMsWUFBWSxDQUFDLGdCQUFnQixFQUFFLEVBQUUsaUJBQWlCLEVBQUUsS0FBSyxFQUFFLENBQUMsRUFBQTs7b0JBQXhFLFNBQXdFLENBQUM7b0JBQ3pFLHFCQUFNLEtBQUssQ0FBQyxNQUFNLEVBQUUsRUFBQTs7b0JBQXBCLFNBQW9CLENBQUM7b0JBQ3JCLHNCQUFPLEtBQUssRUFBQzs7OztDQUNkO0FBRUQsTUFBTSxVQUFnQixzQkFBc0IsQ0FDMUMsS0FBNkIsRUFDN0IsUUFBZ0IsRUFDaEIsT0FBZ0IsRUFDaEIsY0FBc0Q7Ozs7d0JBRXRELHFCQUFNLEtBQUssQ0FBQyxZQUFZLFlBQUcsUUFBUSxVQUFBLElBQUssY0FBYyxFQUFHLEVBQUE7O29CQUF6RCxTQUF5RCxDQUFDO3lCQUN0RCxDQUFBLENBQUMsT0FBTyxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUEsRUFBekIsd0JBQXlCO29CQUMzQixxQkFBTSxLQUFLLENBQUMsTUFBTSxFQUFFLEVBQUE7O29CQUFwQixTQUFvQixDQUFDOzs7Ozs7Q0FFeEIifQ==